<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{headerText}}</h1>
    </div>
  </div>
  <div class="row no-gutters">
   <div class="row no-gutters">
    <mat-radio-group aria-label="Select an option" (change)="showValue.next($event.value)">
      <mat-radio-button value="0" checked="true">{{defaultText}}</mat-radio-button> &nbsp;
      <mat-radio-button value="1" >Show From My Department</mat-radio-button> &nbsp;
      <mat-radio-button value="2" >Show All Depts</mat-radio-button>
    </mat-radio-group>
  </div>
  </div>

  <div class="row">
    <div class="col-xs-12">

      <div id="gridTrainingTaskHistory">
        <div class="row">
          <div class="col-xs-12">
            <aims-common-table id="self-trained-table" 
                [dataSource]="trainingTaskHistory | async" 
                [header]="tableHeader" 
                [pageSize]="10"
                [permissions]="tablePermissions" 
                [defaultTableState]="{ sort:{ active : 'fullName', direction: 'asc' }}">

              <aims-common-table-dynamic-row id="button" >
                <ng-template viewMode let-element let-idx="idx">
                  <aims-common-button-mini
                    *ngIf="element.employeeId != empId"
                    (click)="certifyTraining(element.qtHistoryId, idx)"
                    title="Certify"
                    aria-label="Certify">
                    Cert
                  </aims-common-button-mini>

                  <aims-common-button-mini
                    *ngIf="element.employeeId != empId"
                    (click)="openRevokeComment(element, idx)"
                    title="Revoke"
                    aria-label="Revoke">
                    Rev
                  </aims-common-button-mini>
                </ng-template>
              </aims-common-table-dynamic-row>
            </aims-common-table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
